import { render, staticRenderFns } from "./SchoolEventPage.vue?vue&type=template&id=bfb3f236&scoped=true&"
import script from "./SchoolEventPage.vue?vue&type=script&lang=ts&"
export * from "./SchoolEventPage.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolEventPage.vue?vue&type=style&index=0&id=bfb3f236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb3f236",
  null
  
)

export default component.exports